(() => {
  const track = (eventName, payload = {}) => {
    if (typeof window.essanceTrack === "function") {
      window.essanceTrack(eventName, payload);
    }
  };

  const revealItems = document.querySelectorAll(".reveal");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -20px 0px" }
  );

  revealItems.forEach((item, index) => {
    item.style.transitionDelay = `${Math.min(index * 65, 280)}ms`;
    observer.observe(item);
  });

  const productRoot = document.querySelector("[data-analytics-product]");
  if (productRoot) {
    track("view_item", {
      ecommerce: {
        currency: window.ESSANCE_ANALYTICS?.currency || "USD",
        value: Number(productRoot.dataset.productPrice || 0),
        items: [
          {
            item_id: productRoot.dataset.productId,
            item_name: productRoot.dataset.productTitle,
            item_variant: productRoot.dataset.productVariantId,
            item_brand: productRoot.dataset.productVendor || window.ESSANCE_ANALYTICS?.shopName || "Essance",
            item_category: productRoot.dataset.productType || "Skincare"
          }
        ]
      }
    });
  }

  document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
    form.addEventListener("submit", () => {
      const scopedProduct = form.closest("[data-analytics-product]") || productRoot;
      track("add_to_cart", {
        ecommerce: {
          currency: window.ESSANCE_ANALYTICS?.currency || "USD",
          value: Number(scopedProduct?.dataset.productPrice || 0),
          items: [
            {
              item_id: scopedProduct?.dataset.productId || "",
              item_name: scopedProduct?.dataset.productTitle || "",
              item_variant: scopedProduct?.dataset.productVariantId || "",
              item_brand: scopedProduct?.dataset.productVendor || window.ESSANCE_ANALYTICS?.shopName || "Essance",
              item_category: scopedProduct?.dataset.productType || "Skincare",
              quantity: Number(form.querySelector("[name='quantity']")?.value || 1)
            }
          ]
        }
      });
    });
  });

  document.querySelectorAll("a[href*='/checkout']").forEach((link) => {
    link.addEventListener("click", () => {
      track("begin_checkout", {
        checkout_entry: "checkout_link_click",
        link_text: link.textContent?.trim() || ""
      });
    });
  });

  document.querySelectorAll("form[action*='/checkout']").forEach((form) => {
    form.addEventListener("submit", () => {
      track("begin_checkout", {
        checkout_entry: "checkout_form_submit"
      });
    });
  });

  document.querySelectorAll("form[action*='/contact']").forEach((form) => {
    form.addEventListener("submit", () => {
      track("contact_submit", {
        form_type: "contact",
        page_path: window.location.pathname
      });
    });
  });

  document.querySelectorAll("[data-promo-click]").forEach((promo) => {
    promo.addEventListener("click", () => {
      track("select_promotion", {
        promotion_name: promo.dataset.promoName || promo.textContent?.trim() || "Promo ticker"
      });
    });
  });

  const mobileNavToggle = document.querySelector("[data-mobile-nav-toggle]");
  const mobileNavDrawer = document.querySelector("[data-mobile-nav-drawer]");
  if (mobileNavToggle && mobileNavDrawer) {
    const setMobileNav = (open) => {
      mobileNavToggle.setAttribute("aria-expanded", open ? "true" : "false");
      mobileNavDrawer.hidden = !open;
    };

    mobileNavToggle.addEventListener("click", () => {
      const expanded = mobileNavToggle.getAttribute("aria-expanded") === "true";
      setMobileNav(!expanded);
    });

    mobileNavDrawer.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setMobileNav(false));
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth > 989) setMobileNav(false);
    });
  }

  document.querySelectorAll(".faq-list").forEach((faqList) => {
    faqList.querySelectorAll("details").forEach((current) => {
      current.addEventListener("toggle", () => {
        if (!current.open) return;
        faqList.querySelectorAll("details").forEach((item) => {
          if (item !== current) item.open = false;
        });
      });
    });
  });

  document.querySelectorAll("[data-faq-controls]").forEach((faqRoot) => {
    const chips = Array.from(faqRoot.querySelectorAll("[data-faq-filter]"));
    const search = faqRoot.querySelector("[data-faq-search]");
    const section = faqRoot.closest(".faq");
    const list = section?.querySelector("[data-faq-list]");
    const empty = section?.querySelector("[data-faq-empty]");
    if (!list) return;

    const items = Array.from(list.querySelectorAll("[data-faq-item]"));
    let activeFilter =
      chips.find((chip) => chip.classList.contains("is-active"))?.dataset.faqFilter ||
      chips[0]?.dataset.faqFilter ||
      "";

    const applyFilters = () => {
      const term = (search?.value || "").trim().toLowerCase();
      let visibleCount = 0;

      items.forEach((item) => {
        const category = item.dataset.faqCategory || "";
        const content = item.dataset.faqText || "";
        const matchesCategory = category === activeFilter;
        const matchesSearch = !term || content.includes(term);
        const visible = matchesCategory && matchesSearch;
        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
    };

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        activeFilter = chip.dataset.faqFilter || activeFilter;
        chips.forEach((node) => {
          const isActive = node === chip;
          node.classList.toggle("is-active", isActive);
          node.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        applyFilters();
      });
    });

    if (search) {
      search.addEventListener("input", applyFilters);
    }

    applyFilters();
  });

  document.querySelectorAll(".ingredient-track").forEach((track) => {
    track.innerHTML = `${track.innerHTML}${track.innerHTML}`;
  });

  document.querySelectorAll(".brand-track").forEach((track) => {
    let groups = Array.from(track.querySelectorAll(".brand-track__group"));
    if (groups.length === 1) {
      track.appendChild(groups[0].cloneNode(true));
      groups = Array.from(track.querySelectorAll(".brand-track__group"));
    }

    const firstGroup = groups[0];
    if (!firstGroup) return;

    const syncBrandTickerLoop = () => {
      const groupWidth = Math.ceil(firstGroup.getBoundingClientRect().width);
      if (!groupWidth) return;

      track.style.setProperty("--brand-loop-distance", `${groupWidth}px`);

      const pixelsPerSecond = 32;
      const duration = Math.min(140, Math.max(40, Math.round(groupWidth / pixelsPerSecond)));
      track.style.setProperty("--brand-loop-duration", `${duration}s`);
    };

    syncBrandTickerLoop();
    window.addEventListener("resize", syncBrandTickerLoop, { passive: true });
  });

  const quizRoot = document.querySelector("[data-routine-quiz]");
  if (quizRoot) {
    const assetImages = {
      revitalizing: quizRoot.dataset.imageRevitalizing || "",
      dragons_blood: quizRoot.dataset.imageDragonsBlood || "",
      clarifying: quizRoot.dataset.imageClarifying || "",
      multifruit: quizRoot.dataset.imageMultifruit || "",
      charco: quizRoot.dataset.imageCharco || "",
      hair: quizRoot.dataset.imageHair || ""
    };
    const stage = quizRoot.querySelector("[data-quiz-stage]");
    const questionKicker = quizRoot.querySelector("[data-quiz-question-kicker]");
    const questionTitle = quizRoot.querySelector("[data-quiz-question-title]");
    const questionCopy = quizRoot.querySelector("[data-quiz-question-copy]");
    const optionsRoot = quizRoot.querySelector("[data-quiz-options]");
    const progressFill = quizRoot.querySelector("[data-quiz-progress-fill]");
    const progressStep = quizRoot.querySelector("[data-quiz-step-label]");
    const progressType = quizRoot.querySelector("[data-quiz-step-type]");
    const backButton = quizRoot.querySelector("[data-quiz-back]");
    const nextButton = quizRoot.querySelector("[data-quiz-next]");
    const stageRestartButton = quizRoot.querySelector("[data-quiz-restart-stage]");
    const restartButton = quizRoot.querySelector("[data-quiz-restart]");
    const resultWrap = quizRoot.querySelector("[data-quiz-result]");
    const resultLabel = quizRoot.querySelector("[data-quiz-result-label]");
    const resultTitle = quizRoot.querySelector("[data-quiz-title]");
    const resultSummary = quizRoot.querySelector("[data-quiz-summary]");
    const resultBadges = quizRoot.querySelector("[data-quiz-badges]");
    const resultReasons = quizRoot.querySelector("[data-quiz-reasons]");
    const resultRationale = quizRoot.querySelector("[data-quiz-rationale]");
    const resultLink = quizRoot.querySelector("[data-quiz-link]");
    const resultAlert = quizRoot.querySelector("[data-quiz-alert]");
    const resultSteps = quizRoot.querySelector("[data-quiz-steps]");
    const resultLineProducts = quizRoot.querySelector("[data-quiz-line-products]");
    const featuredProductCard = quizRoot.querySelector("[data-quiz-featured-product]");
    const featuredProductLink = quizRoot.querySelector("[data-quiz-featured-link]");
    const featuredProductImage = quizRoot.querySelector("[data-quiz-featured-image]");
    const featuredProductFallback = quizRoot.querySelector("[data-quiz-featured-fallback]");
    const featuredProductTitle = quizRoot.querySelector("[data-quiz-featured-title]");
    const featuredProductTitleLink = quizRoot.querySelector("[data-quiz-featured-title-link]");
    const featuredProductConcern = quizRoot.querySelector("[data-quiz-featured-concern]");
    const featuredProductPrice = quizRoot.querySelector("[data-quiz-featured-price]");
    const featuredProductCta = quizRoot.querySelector("[data-quiz-featured-cta]");
    const productCatalog = Array.from(quizRoot.querySelectorAll("[data-quiz-line-product]"));
    if (resultWrap) resultWrap.hidden = true;
    const routines = {
      revitalizing: {
        title: "Revitalizing Ritual",
        label: "Dry / mature support",
        link: "/collections/revitalizing-skincare-line",
        rationale:
          "Revitalizing is the restoring line for skin that feels dry, depleted, or in need of more comfort. It is built to bring moisture back into the routine and help skin feel softer, steadier, and more supported over time.",
        summary:
          "Your answers point toward dehydration, barrier fatigue, and a need for deeper antioxidant-led nourishment. Revitalizing is designed to bring back comfort, reinforce the moisture barrier, and leave skin feeling softer and more resilient.",
        steps: [
          {
            step: "Step 1",
            title: "Revitalizing Facial Cleanser",
            why: "This cleanser gives the routine a gentle start while helping skin stay comfortable.",
            usage: "Use it first to cleanse the skin without pushing it toward a tighter, drier feel.",
            price: "$26.00",
            link: "/products/revitalizing-facial-cleanser"
          },
          {
            step: "Step 2",
            title: "Revitalizing Facial Toner",
            why: "The toner brings in an early layer of hydration and helps reset the skin after cleansing.",
            usage: "Apply after cleansing to prep the skin for the treatment steps that follow.",
            price: "$14.75",
            link: "/products/revitalizing-facial-toner"
          },
          {
            step: "Step 3",
            title: "Revitalizing Facial Serum",
            why: "The serum is the main treatment step, focused on helping skin feel replenished and more revived.",
            usage: "Use it next as the concentrated layer that brings deeper support into the ritual.",
            price: "$12.00 - $44.00",
            link: "/products/revitalizing-facial-serum"
          },
          {
            step: "Step 4",
            title: "Revitalizing Facial Moisturizer",
            why: "The moisturizer finishes the routine by sealing in comfort and helping the skin stay soft.",
            usage: "Apply last to lock in moisture and complete the ritual.",
            price: "$33.75",
            link: "/products/revitalizing-facial-moisturizer"
          }
        ]
      },
      dragons_blood: {
        title: "Dragon's Blood Ritual",
        label: "Combination / barrier balancing",
        link: "/collections/dragons-blood",
        rationale:
          "Dragon's Blood is the restoring line for skin that feels mixed, reactive, or slightly out of rhythm. It helps bring the routine back into balance when some areas feel oilier, others feel drier, and the overall goal is steadier, calmer skin.",
        summary:
          "Your responses suggest combination behavior: more oil in some areas, more dehydration in others, and a barrier that benefits from a more protective, balancing routine. Dragon's Blood gives Essance's most flexible skin-balancing result.",
        steps: [
          {
            step: "Step 1",
            title: "Dragon's Blood Cleanser",
            why: "This cleanser clears away buildup while keeping the skin feeling balanced and comfortable.",
            usage: "Use it first to wash away the day and prep the skin for the rest of the ritual.",
            price: "$30.00",
            link: "/products/dragons-blood-cleanser"
          },
          {
            step: "Step 2",
            title: "Dragon's Blood Toner",
            why: "The toner helps reset the skin after cleansing and brings in a calmer, more refreshed feel.",
            usage: "Apply after cleansing to lightly hydrate and ready the skin for treatment.",
            price: "$15.50",
            link: "/products/dragons-blood-toner"
          },
          {
            step: "Step 3",
            title: "Dragon's Blood Serum",
            why: "The serum is the focused treatment step, made to support smoother, more balanced-looking skin.",
            usage: "Use it next as the main restorative layer in the routine.",
            price: "$45.15",
            link: "/products/dragons-blood-serum"
          },
          {
            step: "Step 4",
            title: "Dragon's Blood Moisturizer",
            why: "The moisturizer seals everything in and helps the skin finish soft, protected, and settled.",
            usage: "Apply last to lock in moisture and complete the ritual.",
            price: "$19.00 - $36.00",
            link: "/products/dragons-blood-moisturizer"
          }
        ]
      },
      clarifying: {
        title: "Clarifying Ritual",
        label: "Congestion / sensitivity support",
        link: "/collections/shop-all-products",
        rationale:
          "Clarifying is the balancing line for skin that feels congested, breakout-prone, or easily overwhelmed by buildup. It is meant to help the routine feel cleaner, calmer, and more controlled without leaning too harsh.",
        summary:
          "Your responses suggest a skin pattern driven by congestion, inflammation, or excess oil. Clarifying is built to reduce visible buildup, restore balance, and support calmer-looking skin without making reactive areas feel overworked.",
        steps: [
          {
            step: "Step 1",
            title: "Clarifying Cleanser",
            why: "This cleanser lifts away buildup and gives the routine a cleaner starting point.",
            usage: "Use it first to wash away excess oil, residue, and daily congestion.",
            price: "$26.00",
            link: "/products/clarifying-cleanser"
          },
          {
            step: "Step 2",
            title: "Clarifying Toner",
            why: "The toner helps reset the skin after cleansing and supports a fresher, more balanced feel.",
            usage: "Apply after cleansing to prep the skin for the next step in the ritual.",
            price: "$14.75",
            link: "/products/clarifying-toner"
          },
          {
            step: "Step 3",
            title: "Organic Beet Clay Masque",
            why: "This masque works as the deeper reset step when the skin needs extra clearing attention.",
            usage: "Use it through the week when your skin feels more congested than usual.",
            price: "$21.00",
            link: "/products/organic-beet-clay-masque"
          },
          {
            step: "Step 4",
            title: "Clarifying Moisturizer",
            why: "The moisturizer helps the skin finish balanced so the routine does not end feeling stripped.",
            usage: "Apply last to bring the routine back into a calmer, more settled finish.",
            price: "$30.00",
            link: "/products/clarifying-moisturizer"
          }
        ]
      },
      multifruit: {
        title: "Multi-Fruit Peptide & Collagen Ritual",
        label: "Firming / collagen support",
        link: "/collections/multifruit-peptide-collagen",
        rationale:
          "Multi-Fruit is the support line for skin goals centered on firmness, smoothness, and visible vitality. It is designed for routines that want more bounce, glow, and a more refined overall finish.",
        summary:
          "Your answers put elasticity, firmness, and collagen support at the center of your routine goals. Multi-Fruit is the most direct Essance route when you want more bounce, tone, and visible resilience.",
        steps: [
          {
            step: "Step 1",
            title: "Multifruit Peptide & Collagen Cleanser",
            why: "This cleanser starts the ritual by refreshing the skin without overcomplicating the first step.",
            usage: "Use it first to prep the skin for the rest of the firming-focused routine.",
            price: "$30.00",
            link: "/products/essance-s-multifruit-peptide-collagen-cleanser"
          },
          {
            step: "Step 2",
            title: "Multifruit Peptide & Collagen Toner",
            why: "The toner adds a first layer of support and helps the skin feel awake and ready for treatment.",
            usage: "Apply after cleansing to move the ritual into its treatment steps.",
            price: "$32.00",
            link: "/products/essance-s-multifruit-peptide-collagen-toner"
          },
          {
            step: "Step 3",
            title: "Multifruit Peptide & Collagen Serum",
            why: "The serum is the main treatment step, focused on helping skin look smoother, firmer, and more energized.",
            usage: "Use it next as the core support layer in the routine.",
            price: "$48.00",
            link: "/products/multifruit-peptide-collagen-serum"
          },
          {
            step: "Step 4",
            title: "Multifruit Peptide & Collagen Moisturizer",
            why: "The moisturizer finishes the ritual by sealing in support and helping the skin feel more supple.",
            usage: "Use the lighter or richer finish depending on when you are doing the ritual.",
            price: "$20.00 - $45.00",
            link: "/products/multifruit-peptide-collagen-night-moisturizer"
          }
        ]
      }
    };

    const questions = [
      {
        id: "primary_concern",
        kicker: "Start here",
        title: "What is your primary skin concern right now?",
        copy: "Choose the concern that feels most important today. The next question will shift based on what you pick so the ritual feels more tailored from the start.",
        type: "single",
        options: [
          {
            value: "dryness",
            label: "Dryness, dehydration, or barrier discomfort",
            detail: "You want more comfort, moisture, and replenishment.",
            scores: { revitalizing: 4, dragons_blood: 1 },
            reason: "You led with dryness and barrier comfort, which naturally pushes the ritual toward more replenishing formulas."
          },
          {
            value: "balance",
            label: "Combination skin that feels unbalanced",
            detail: "You want better harmony between oilier and drier zones.",
            scores: { dragons_blood: 4 },
            reason: "You led with imbalance across different areas of the face, which is the strongest Dragon's Blood signal."
          },
          {
            value: "breakouts",
            label: "Breakouts, congestion, or sensitivity flareups",
            detail: "You want a calmer, clearer-feeling routine.",
            scores: { clarifying: 4, dragons_blood: 1 },
            reason: "You led with congestion or inflammation, which points more strongly toward a clarifying-style ritual."
          },
          {
            value: "aging",
            label: "Fine lines, firmness, or glow support",
            detail: "You want a more lifted, smoother, more radiant look.",
            scores: { multifruit: 4, revitalizing: 1 },
            reason: "You led with structure, firmness, or radiance, which moves the ritual toward Multi-Fruit and supportive antioxidant care."
          }
        ]
      },
      {
        id: "pores",
        kicker: "Sebum + pore behavior",
        title: "How would you categorize your pores and visible congestion?",
        copy: "This tells us whether your routine should prioritize weekly detox support, balancing toners, or richer moisture-forward formulas.",
        type: "single",
        options: [
          {
            value: "barely-visible",
            label: "Barely visible pores",
            detail: "More common in dry or low-sebum skin.",
            scores: { revitalizing: 3 },
            reason: "Barely visible pores usually pair with lower oil flow and a greater need for supportive hydration."
          },
          {
            value: "nose-cheeks",
            label: "Noticeable mostly around the nose and inner cheeks, often with blackheads",
            detail: "Localized congestion without full-face oiliness.",
            scores: { dragons_blood: 3 },
            flags: { charco_masque: true },
            reason: "Localized congestion points toward a balancing routine with optional weekly extraction support."
          },
          {
            value: "everywhere",
            label: "Highly visible across much of the face and frequently clogged",
            detail: "Higher congestion and oil regulation need.",
            scores: { clarifying: 5 },
            reason: "Frequent visible congestion across the face is a strong clarifying signal."
          },
          {
            value: "dry-edges",
            label: "Small pores, but the surrounding skin gets dry or flaky",
            detail: "Often a dehydrated-skin pattern.",
            scores: { revitalizing: 2, dragons_blood: 1 },
            reason: "You described dehydration around the pore area rather than classic oil-led congestion."
          }
        ]
      },
      {
        id: "breakouts",
        kicker: "Inflammation markers",
        title: "Which breakout or irritation pattern sounds most like you?",
        copy: "We use this to separate chronic congestion from occasional hormonal flareups and shaving-driven inflammation.",
        type: "single",
        options: [
          {
            value: "frequent",
            label: "Frequent active breakouts across the face",
            detail: "Suggests chronic inflammatory congestion.",
            scores: { clarifying: 6 },
            reason: "Frequent active breakouts are the clearest sign that a clarifying-first routine should be considered."
          },
          {
            value: "occasional",
            label: "Occasional chin or jawline flareups tied to stress or hormones",
            detail: "Often needs balancing more than full acne stripping.",
            scores: { dragons_blood: 4, clarifying: 1 },
            reason: "Occasional cyclical or stress-linked flareups often respond better to barrier-balancing than to an aggressively acne-first routine."
          },
          {
            value: "rare",
            label: "Rarely or never",
            detail: "Lets barrier repair or anti-aging concerns take the lead.",
            scores: { revitalizing: 2, multifruit: 2 },
            reason: "Because breakouts are not a dominant issue, the recommendation can focus more directly on comfort, glow, or structural support."
          },
          {
            value: "shaving",
            label: "More razor bumps, ingrowns, or irritation from shaving than classic acne",
            detail: "Calls for Charco support as an add-on, not necessarily a full acne routine.",
            flags: { shaving: true, charco_masque: true },
            scores: { dragons_blood: 2, clarifying: 2 },
            reason: "The irritation you described sounds more connected to grooming friction and ingrowns than traditional acne alone."
          }
        ]
      },
      {
        id: "sensitivity",
        kicker: "Sensitivity profile",
        title: "How reactive is your skin to sun, weather, and new products?",
        copy: "This helps us decide whether your skin can tolerate stronger clarifying signals or needs a calmer route with more protective ingredients.",
        type: "single",
        options: [
          {
            value: "high",
            label: "Highly reactive, with redness, stinging, eczema, or psoriasis tendencies",
            detail: "Requires gentler handling and safer clarifying detours.",
            scores: { clarifying: 2 },
            flags: { sensitive_warning: true },
            reason: "You reported a highly reactive barrier, so any recommendation needs to be especially careful about over-correction."
          },
          {
            value: "medium",
            label: "Occasionally irritated by weather, strong sunscreens, or harsh routines",
            detail: "Mild sensitivity with barrier-awareness needed.",
            scores: { dragons_blood: 2 },
            reason: "You signaled a barrier that is not fully reactive but still benefits from a balancing, calming approach."
          },
          {
            value: "low",
            label: "Generally resilient and tolerant",
            detail: "Allows actives and structural goals to lead more confidently.",
            scores: { multifruit: 2, revitalizing: 1 },
            reason: "A more resilient barrier gives us more room to prioritize glow, firmness, or deeper treatment goals."
          }
        ]
      },
      {
        id: "structural",
        kicker: "Long-term skin goals",
        title: "Beyond balancing oil or dryness, what is your main visible concern?",
        copy: "This helps us decide whether to lean more toward peptides and collagen support, pigment-balancing, or richer antioxidant restoration.",
        type: "single",
        options: [
          {
            value: "lines",
            label: "Fine lines, firmness loss, and visible aging",
            detail: "High collagen-support priority.",
            scores: { multifruit: 6 },
            flags: { device: true },
            reason: "You identified structural aging and firmness as the priority, which is exactly where the Multi-Fruit line is strongest."
          },
          {
            value: "pigment",
            label: "Post-breakout marks, uneven tone, or lingering redness",
            detail: "Suggests balancing + repair.",
            scores: { dragons_blood: 4 },
            reason: "Uneven tone and post-breakout marks align well with Dragon's Blood's reparative, calming profile."
          },
          {
            value: "dullness",
            label: "Dullness, fatigue, and lack of radiance",
            detail: "Often antioxidant and hydration driven.",
            scores: { revitalizing: 4 },
            reason: "You described a skin state that sounds more depleted than congested, which makes antioxidant-rich hydration the better first move."
          }
        ]
      },
      {
        id: "eye",
        kicker: "Orbital care",
        title: "How would you describe the skin around your eyes?",
        copy: "This does not decide the full collection by itself, but it helps us layer in smarter add-ons.",
        type: "single",
        options: [
          {
            value: "dry-lines",
            label: "Dry, crepey, or fine lines are the main issue",
            detail: "More peptide-led orbital support.",
            flags: { eye_gel: true },
            reason: "You noted line-focused eye concerns, which makes a more treatment-forward eye product worth adding."
          },
          {
            value: "puffy",
            label: "Puffiness, dark circles, or visible fatigue",
            detail: "Calls for circulation-support add-on.",
            flags: { eye_creme: true },
            reason: "You described puffiness or dark circles, which makes a circulation-supporting eye add-on a smart fit."
          },
          {
            value: "none",
            label: "No major eye-area concern right now",
            detail: "Keeps the result more streamlined.",
            reason: "You did not flag a major eye concern, so the recommendation can stay focused on the face routine itself."
          }
        ]
      }
    ];

    const state = {
      currentStep: 0,
      answers: {}
    };

    const tieBreaker = ["dragons_blood", "revitalizing", "clarifying", "multifruit"];

    const concernFollowUps = {
      dryness: {
        kicker: "Hydration detail",
        title: "When your skin is off, which of these feels most true?",
        copy: "This helps us separate deeper barrier depletion from simple dullness or occasional dryness.",
        options: [
          {
            value: "tight",
            label: "It feels tight, uncomfortable, and sometimes flaky",
            detail: "Strong signal for depleted moisture barrier and dryness.",
            scores: { revitalizing: 5, dragons_blood: 1 },
            reason: "You described the kind of tightness and flaking usually tied to moisture loss and a depleted barrier."
          },
          {
            value: "dull-dry",
            label: "It looks dull and tired even when it is not actively flaky",
            detail: "Often points to antioxidant and hydration support.",
            scores: { revitalizing: 4, multifruit: 1 },
            reason: "You described skin that feels depleted and low on radiance, which points toward richer antioxidant hydration."
          },
          {
            value: "dry-patches",
            label: "Some areas stay dry no matter what I put on",
            detail: "May need richer barrier support with balancing backup.",
            scores: { revitalizing: 4, dragons_blood: 2 },
            reason: "Persistent dry patches suggest the barrier needs stronger support instead of just a lighter hydration layer."
          }
        ]
      },
      balance: {
        kicker: "Balancing detail",
        title: "How does that imbalance usually show up?",
        copy: "This helps us tell the difference between classic combination behavior and congestion-heavy skin.",
        options: [
          {
            value: "combo",
            label: "My cheeks feel comfortable or dry, but my forehead or nose gets oily",
            detail: "Classic combination pattern.",
            scores: { dragons_blood: 5 },
            reason: "You described combination behavior, where some zones need regulation while others need protection."
          },
          {
            value: "nose-cheeks",
            label: "The nose and inner cheeks collect blackheads or visible congestion",
            detail: "Localized congestion without full-face oiliness.",
            scores: { dragons_blood: 3, clarifying: 1 },
            flags: { charco_masque: true },
            reason: "Localized congestion points toward a balancing routine with a little extra pore support."
          },
          {
            value: "reactive-balance",
            label: "My skin swings between oily and irritated depending on weather or products",
            detail: "Often needs calm barrier-balancing more than stronger acne correction.",
            scores: { dragons_blood: 4, clarifying: 1 },
            reason: "You described a more reactive kind of imbalance, which usually benefits from calmer barrier-balancing support."
          }
        ]
      },
      breakouts: {
        kicker: "Clarifying detail",
        title: "Which version of that concern sounds most like you?",
        copy: "This helps us tell the difference between active breakouts, congestion, and shaving or sensitivity-led irritation.",
        options: [
          {
            value: "frequent",
            label: "Frequent active breakouts across the face",
            detail: "Strong clarifying signal.",
            scores: { clarifying: 6 },
            reason: "Frequent active breakouts are the clearest sign that a clarifying-first ritual should be considered."
          },
          {
            value: "everywhere",
            label: "More clogged pores, visible oil, and recurring congestion than inflamed spots",
            detail: "Higher congestion and oil regulation need.",
            scores: { clarifying: 5, dragons_blood: 1 },
            reason: "You reported congestion and oil buildup more than simple dryness, which strengthens the clarifying route."
          },
          {
            value: "shaving",
            label: "More razor bumps, ingrowns, or irritation from shaving than classic acne",
            detail: "Still needs calming support, but not necessarily a harsh acne routine.",
            flags: { shaving: true, charco_masque: true },
            scores: { dragons_blood: 2, clarifying: 2 },
            reason: "The irritation you described sounds more connected to grooming friction and ingrowns than traditional acne alone."
          },
          {
            value: "sensitive-breakouts",
            label: "Breakouts happen, but my skin is also very reactive or easily irritated",
            detail: "Clarifying support with more caution built in.",
            flags: { sensitive_warning: true },
            scores: { clarifying: 3, dragons_blood: 2 },
            reason: "You described breakout-prone skin with a reactive barrier, so the ritual has to clarify without overworking your skin."
          }
        ]
      },
      aging: {
        kicker: "Firmness + glow detail",
        title: "What are you hoping to improve most?",
        copy: "This helps us separate collagen support from dullness or pigment-led concerns.",
        options: [
          {
            value: "lines",
            label: "Fine lines, firmness loss, and visible aging",
            detail: "High collagen-support priority.",
            scores: { multifruit: 6 },
            flags: { device: true },
            reason: "You identified structural aging and firmness as the priority, which is exactly where the Multi-Fruit line is strongest."
          },
          {
            value: "dullness",
            label: "Dullness, fatigue, and lack of radiance",
            detail: "Often antioxidant and hydration driven.",
            scores: { revitalizing: 4, multifruit: 1 },
            reason: "You described a skin state that sounds more depleted than congested, which makes antioxidant-rich hydration the better first move."
          },
          {
            value: "pigment",
            label: "Uneven tone, post-breakout marks, or lingering redness",
            detail: "Suggests balancing + repair.",
            scores: { dragons_blood: 4 },
            reason: "Uneven tone and post-breakout marks align well with Dragon's Blood's reparative, calming profile."
          }
        ]
      }
    };

    const getAnswer = (questionId) => state.answers[questionId];
    const getQuestionByStep = (stepIndex) => {
      const question = questions[stepIndex];
      if (!question) return question;
      if (question.id !== "pores") return question;

      const concern = getAnswer("primary_concern");
      const followUp = concernFollowUps[concern];
      if (!followUp) return question;

      return {
        ...question,
        kicker: followUp.kicker,
        title: followUp.title,
        copy: followUp.copy,
        options: followUp.options
      };
    };
    const hasAnswer = (question) =>
      question.type === "multi"
        ? Array.isArray(getAnswer(question.id)) && getAnswer(question.id).length > 0
        : typeof getAnswer(question.id) === "string" && getAnswer(question.id).length > 0;

    const selectedOptionsForQuestion = (question) => {
      const answer = getAnswer(question.id);
      if (question.type === "multi") {
        const values = Array.isArray(answer) ? answer : [];
        return question.options.filter((option) => values.includes(option.value));
      }
      return question.options.filter((option) => option.value === answer);
    };

    const flattenSelections = () =>
      questions.flatMap((question, index) =>
        selectedOptionsForQuestion(getQuestionByStep(index)).map((option) => ({
          question: getQuestionByStep(index),
          option
        }))
      );

    const calculateResult = () => {
      const scoreBoard = {
        revitalizing: 0,
        dragons_blood: 0,
        clarifying: 0,
        multifruit: 0
      };
      const flags = {};
      const reasons = [];

      flattenSelections().forEach(({ option }) => {
        Object.entries(option.scores || {}).forEach(([key, value]) => {
          scoreBoard[key] = (scoreBoard[key] || 0) + value;
        });
        Object.entries(option.flags || {}).forEach(([key, value]) => {
          if (value) flags[key] = true;
        });
        if (option.reason && reasons.length < 5) reasons.push(option.reason);
      });

      const maxScore = Math.max(...Object.values(scoreBoard));
      const tied = Object.keys(scoreBoard).filter((key) => scoreBoard[key] === maxScore);
      let winner = tieBreaker.find((key) => tied.includes(key)) || tied[0] || "dragons_blood";

      const alerts = [];

      if (winner === "clarifying" && flags.sensitive_warning) {
        flags.beet_masque = true;
        alerts.push(
          "You also flagged sensitivity or eczema/psoriasis-style reactivity, so the recommendation favors the gentler Organic Beet Clay Masque over a harsher weekly detox option."
        );
      }

      return { winner, scoreBoard, flags, reasons, alerts };
    };

    const renderOption = (question, option, stepIndex) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "quiz-option";
      button.dataset.value = option.value;

      const label = document.createElement("strong");
      label.textContent = option.label;
      const detail = document.createElement("span");
      detail.textContent = option.detail || "";

      button.append(label, detail);

      const answer = getAnswer(question.id);
      const isActive =
        question.type === "multi"
          ? Array.isArray(answer) && answer.includes(option.value)
          : answer === option.value;
      if (isActive) button.classList.add("is-active");

      button.addEventListener("click", () => {
        if (question.type === "multi") {
          const nextValues = new Set(Array.isArray(getAnswer(question.id)) ? getAnswer(question.id) : []);
          if (nextValues.has(option.value)) nextValues.delete(option.value);
          else nextValues.add(option.value);
          state.answers[question.id] = Array.from(nextValues);
        } else {
          state.answers[question.id] = option.value;
        }

        track("quiz_interaction", {
          quiz_group: question.id,
          quiz_value: option.value
        });

        renderQuestion();
      });

      return button;
    };

    const renderQuestion = () => {
      const question = getQuestionByStep(state.currentStep);
      if (!question || !optionsRoot) return;

      if (
        question.type === "single" &&
        typeof getAnswer(question.id) === "string" &&
        !question.options.some((option) => option.value === getAnswer(question.id))
      ) {
        delete state.answers[question.id];
      }

      questionKicker.textContent = question.kicker;
      questionTitle.textContent = question.title;
      questionCopy.textContent = question.copy;
      progressStep.textContent = `Question ${state.currentStep + 1} of ${questions.length}`;
      progressType.textContent = question.type === "multi" ? "Select any that fit" : "Choose the closest fit";
      progressFill.style.width = `${((state.currentStep + 1) / questions.length) * 100}%`;

      optionsRoot.innerHTML = "";
      question.options.forEach((option) => {
        optionsRoot.appendChild(renderOption(question, option, state.currentStep));
      });

      backButton.disabled = state.currentStep === 0;
      nextButton.disabled = !hasAnswer(question);
      nextButton.textContent = state.currentStep === questions.length - 1 ? "See My Results" : "Next";
    };

    const renderResult = () => {
      const { winner, flags, reasons, alerts } = calculateResult();
      const routine = routines[winner];
      if (!routine) return;

      if (stage) stage.hidden = true;
      if (resultWrap) resultWrap.hidden = false;

      resultLabel.textContent = `Your Essance recommendation • ${routine.label}`;
      resultTitle.textContent = routine.title;
      resultSummary.textContent = routine.summary;
      resultRationale.textContent = routine.rationale;
      resultLink.href = routine.link;

      const lineProducts = productCatalog.filter((item) => item.dataset.line === winner);
      const featuredProduct = lineProducts[0];

      if (featuredProductCard && featuredProduct) {
        const featuredLink = featuredProduct.dataset.link || routine.link;
        featuredProductCard.hidden = false;

        if (featuredProductLink) featuredProductLink.href = featuredLink;
        if (featuredProductTitleLink) featuredProductTitleLink.href = featuredLink;
        if (featuredProductCta) featuredProductCta.href = featuredLink;
        if (featuredProductTitle) featuredProductTitle.textContent = featuredProduct.dataset.title || routine.title;
        if (featuredProductConcern) featuredProductConcern.textContent = featuredProduct.dataset.concern || "";
        if (featuredProductPrice) featuredProductPrice.textContent = featuredProduct.dataset.price || "";

        if (featuredProductImage) {
          if (featuredProduct.dataset.image) {
            featuredProductImage.src = featuredProduct.dataset.image;
            featuredProductImage.alt = featuredProduct.dataset.title || routine.title;
            featuredProductImage.hidden = false;
            if (featuredProductFallback) featuredProductFallback.hidden = true;
          } else {
            featuredProductImage.hidden = true;
            featuredProductImage.removeAttribute("src");
            featuredProductImage.alt = "";
            if (featuredProductFallback) featuredProductFallback.hidden = false;
          }
        }
      } else if (featuredProductCard) {
        featuredProductCard.hidden = true;
      }

      if (resultBadges) {
        resultBadges.innerHTML = "";
        [
          "Clean botanical formulas",
          "Free shipping over $50",
          "Personalized collection match"
        ].forEach((text) => {
          const badge = document.createElement("span");
          badge.className = "quiz-result-badge";
          badge.textContent = text;
          resultBadges.appendChild(badge);
        });
      }

      if (resultReasons) {
        resultReasons.innerHTML = "";
        reasons.slice(0, 4).forEach((reason) => {
          const item = document.createElement("li");
          item.textContent = reason;
          resultReasons.appendChild(item);
        });
      }

      if (resultAlert) {
        if (alerts.length) {
          resultAlert.hidden = false;
          resultAlert.innerHTML = alerts.map((alert) => `<p>${alert}</p>`).join("");
        } else {
          resultAlert.hidden = true;
          resultAlert.innerHTML = "";
        }
      }

      if (resultSteps) {
        resultSteps.innerHTML = "";
        routine.steps.forEach((step) => {
          const article = document.createElement("article");
          article.className = "quiz-step-card";
          article.innerHTML = `
            <p class="quiz-step-label">${step.step}</p>
            <h5>${step.title}</h5>
            <p>${step.why}</p>
            <p class="quiz-step-usage">${step.usage}</p>
            <div class="quiz-step-meta">
              <span>${step.price}</span>
              <a href="${step.link}">View product</a>
            </div>
          `;
          resultSteps.appendChild(article);
        });
      }

      if (resultLineProducts) {
        resultLineProducts.innerHTML = "";
        lineProducts
          .forEach((item) => {
            const card = document.createElement("article");
            card.className = "quiz-line-product-card";
            const imageMarkup = item.dataset.image
              ? `<img src="${item.dataset.image}" alt="${item.dataset.title || ""}" loading="lazy">`
              : `<div class="quiz-line-product-fallback" aria-hidden="true"></div>`;

            card.innerHTML = `
              <a class="quiz-line-product-media" href="${item.dataset.link || "#"}">
                ${imageMarkup}
              </a>
              <div class="quiz-line-product-copy">
                <div class="quiz-line-product-top">
                  <h5><a href="${item.dataset.link || "#"}">${item.dataset.title || ""}</a></h5>
                </div>
                <p>${item.dataset.concern || ""}</p>
                <div class="quiz-line-product-meta">
                  <strong>Featured ingredient</strong>
                  <span>${item.dataset.ingredients || ""}</span>
                </div>
                <div class="quiz-line-product-actions">
                  <span>${item.dataset.price || ""}</span>
                  <a href="${item.dataset.link || "#"}">View product</a>
                </div>
              </div>
            `;
            resultLineProducts.appendChild(card);
          });
      }

    };

    const resetQuiz = () => {
      state.currentStep = 0;
      state.answers = {};
      if (resultWrap) resultWrap.hidden = true;
      if (stage) stage.hidden = false;
      if (featuredProductCard) {
        featuredProductCard.hidden = true;
      }
      if (featuredProductImage) {
        featuredProductImage.hidden = true;
        featuredProductImage.removeAttribute("src");
        featuredProductImage.alt = "";
      }
      if (featuredProductFallback) {
        featuredProductFallback.hidden = false;
      }
      renderQuestion();
    };

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        const question = getQuestionByStep(state.currentStep);
        if (!question || !hasAnswer(question)) return;
        if (state.currentStep === questions.length - 1) {
          renderResult();
        } else {
          state.currentStep += 1;
          renderQuestion();
        }
      });
    }

    if (backButton) {
      backButton.addEventListener("click", () => {
        if (state.currentStep === 0) return;
        state.currentStep -= 1;
        renderQuestion();
      });
    }

    if (restartButton) restartButton.addEventListener("click", resetQuiz);
    if (stageRestartButton) stageRestartButton.addEventListener("click", resetQuiz);

    if (resultLink) {
      resultLink.addEventListener("click", () => {
        track("quiz_result_click", {
          result_title: resultTitle?.textContent?.trim() || ""
        });
      });
    }

    renderQuestion();
  }

  document.querySelectorAll("[data-ingredient-explorer]").forEach((ingredientRoot) => {
    const panel = ingredientRoot.querySelector("[data-ingredient-panel]");
    const chips = Array.from(ingredientRoot.querySelectorAll("[data-ingredient-chip]"));
    const title = panel?.querySelector("[data-ingredient-title]");
    const description = panel?.querySelector("[data-ingredient-description]");
    const benefit = panel?.querySelector("[data-ingredient-benefit]");
    const source = panel?.querySelector("[data-ingredient-source]");
    const skin = panel?.querySelector("[data-ingredient-skin]");
    const inci = panel?.querySelector("[data-ingredient-inci]");
    const image = panel?.querySelector("[data-ingredient-image]");

    const setPanel = (chip) => {
      if (!chip || !title || !description || !benefit || !source || !skin) return;
      title.textContent = chip.dataset.title || "";
      description.textContent = chip.dataset.description || "";
      benefit.textContent = chip.dataset.benefit || "-";
      source.textContent = chip.dataset.source || "-";
      skin.textContent = chip.dataset.skin || "-";
      if (inci) {
        const inciText = (chip.dataset.inci || "").trim();
        inci.textContent = inciText ? `INCI: ${inciText}` : "";
        inci.hidden = !inciText;
      }
      if (image) {
        if (chip.dataset.image) {
          image.src = chip.dataset.image;
          image.alt = chip.dataset.title || "";
          image.hidden = false;
        } else {
          image.removeAttribute("src");
          image.alt = "";
          image.hidden = true;
        }
      }
    };

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        chips.forEach((node) => node.classList.remove("is-active"));
        chip.classList.add("is-active");
        setPanel(chip);
        track("ingredient_detail_view", {
          ingredient_name: chip.dataset.title || "",
          page_path: window.location.pathname
        });
      });
    });

    const active = chips.find((chip) => chip.classList.contains("is-active")) || chips[0];
    setPanel(active);
  });

  document.querySelectorAll("[data-ingredients-library]").forEach((libraryRoot) => {
    const chips = Array.from(libraryRoot.querySelectorAll("[data-ingredient-filter]"));
    const search = libraryRoot.querySelector("[data-ingredient-search]");
    const grid = libraryRoot.querySelector("[data-ingredient-grid]");
    const empty = libraryRoot.querySelector("[data-ingredient-empty]");
    if (!grid || !chips.length) return;

    const cards = Array.from(grid.querySelectorAll("[data-ingredient-card]"));
    const normalize = (value) => {
      const normalized = String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, "and")
        .replace(/\s+/g, "_")
        .replace(/-/g, "_")
        .replace(/[^a-z0-9_]/g, "");

      const aliases = {
        dragon_blood: "dragons_blood",
        dragonsblood: "dragons_blood",
        multi_fruit: "multifruit",
        multi__fruit: "multifruit",
        all_ingredients: "all"
      };

      return aliases[normalized] || normalized;
    };
    let activeFilter =
      normalize(chips.find((chip) => chip.classList.contains("is-active"))?.dataset.ingredientFilter) ||
      normalize(chips[0]?.dataset.ingredientFilter) ||
      "featured";

    const applyIngredientFilters = () => {
      const term = (search?.value || "").trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryValue =
          card.dataset.ingredientCategory ||
          card.dataset.ingredientLine ||
          card.querySelector(".ingredient-library-card__line")?.textContent ||
          "";
        const categories = String(categoryValue)
          .split(",")
          .map((value) => normalize(value))
          .filter(Boolean);
        const featured = String(card.dataset.ingredientFeatured || "").toLowerCase() === "true";
        const text = card.dataset.ingredientText || "";

        let matchesFilter = false;
        if (activeFilter === "all") matchesFilter = true;
        else if (activeFilter === "featured") matchesFilter = featured;
        else matchesFilter = categories.includes(activeFilter);

        const matchesSearch = !term || text.includes(term);
        const visible = matchesFilter && matchesSearch;
        card.hidden = !visible;
        card.classList.toggle("is-hidden", !visible);
        if (visible) visibleCount += 1;
      });

      if (visibleCount === 0 && activeFilter === "featured" && !term) {
        activeFilter = "all";
        chips.forEach((node) => {
          const normalized = normalize(node.dataset.ingredientFilter || "");
          const isActive = normalized === "all";
          node.classList.toggle("is-active", isActive);
          node.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        applyIngredientFilters();
        return;
      }

      if (empty) empty.hidden = visibleCount !== 0;
    };

    chips.forEach((chip) => {
      chip.addEventListener("click", () => {
        activeFilter = normalize(chip.dataset.ingredientFilter || activeFilter);
        chips.forEach((node) => {
          const isActive = node === chip;
          node.classList.toggle("is-active", isActive);
          node.setAttribute("aria-selected", isActive ? "true" : "false");
        });
        applyIngredientFilters();
      });
    });

    if (search) search.addEventListener("input", applyIngredientFilters);
    applyIngredientFilters();
  });

  document.querySelectorAll("[data-product-experience-tabs]").forEach((root) => {
    const tabs = Array.from(root.querySelectorAll("[data-tab-target]"));
    const panels = Array.from(root.querySelectorAll("[data-tab-panel]"));
    if (!tabs.length || !panels.length) return;

    const selectTab = (target) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabTarget === target;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === target;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => selectTab(tab.dataset.tabTarget));
    });

    const active = tabs.find((tab) => tab.classList.contains("is-active")) || tabs[0];
    selectTab(active.dataset.tabTarget);
  });

  document.querySelectorAll("[data-hero-gallery]").forEach((gallery) => {
    const track = gallery.querySelector("[data-hero-gallery-track]");
    const prev = gallery.querySelector("[data-hero-gallery-prev]");
    const next = gallery.querySelector("[data-hero-gallery-next]");
    const slides = Array.from(gallery.querySelectorAll(".hero-photo-carousel__slide"));
    if (!track || slides.length < 2) return;

    let index = 0;
    let touchStartX = 0;
    let touchDeltaX = 0;
    const lastIndex = slides.length - 1;

    const setIndex = (nextIndex) => {
      if (nextIndex < 0) index = lastIndex;
      else if (nextIndex > lastIndex) index = 0;
      else index = nextIndex;
      track.style.transform = `translate3d(-${index * 100}%, 0, 0)`;
    };

    prev?.addEventListener("click", () => setIndex(index - 1));
    next?.addEventListener("click", () => setIndex(index + 1));

    gallery.addEventListener(
      "touchstart",
      (event) => {
        touchStartX = event.touches[0]?.clientX || 0;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    gallery.addEventListener(
      "touchmove",
      (event) => {
        const currentX = event.touches[0]?.clientX || 0;
        touchDeltaX = currentX - touchStartX;
      },
      { passive: true }
    );

    gallery.addEventListener("touchend", () => {
      if (Math.abs(touchDeltaX) < 42) return;
      if (touchDeltaX < 0) setIndex(index + 1);
      else setIndex(index - 1);
    });
  });

  document.querySelectorAll("[data-before-after]").forEach((slider) => {
    const range = slider.querySelector("[data-before-after-range]");
    const clip = slider.querySelector("[data-after-clip]");
    const handle = slider.querySelector("[data-before-after-handle]");
    if (!range || !clip || !handle) return;

    const update = (value) => {
      const safe = Math.max(0, Math.min(100, Number(value)));
      clip.style.clipPath = `inset(0 0 0 ${safe}%)`;
      handle.style.left = `${safe}%`;
    };

    range.addEventListener("input", (event) => update(event.target.value));
    update(range.value);
  });

  const stickyAtc = document.querySelector("[data-sticky-atc]");
  const mainAtc = document.querySelector("[data-main-atc]");
  if (stickyAtc && mainAtc) {
    const atcObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            stickyAtc.hidden = true;
            stickyAtc.classList.remove("is-visible");
          } else {
            stickyAtc.hidden = false;
            stickyAtc.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.15 }
    );

    atcObserver.observe(mainAtc);
  }

  document.querySelectorAll("[data-testimonial-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-testimonial-track]");
    const prev = carousel.querySelector("[data-testimonial-prev]");
    const next = carousel.querySelector("[data-testimonial-next]");
    if (!track || !prev || !next) return;

    const scrollTestimonials = (direction) => {
      const firstCard = track.querySelector(".testimonial-card");
      const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || "16");
      const distance = (firstCard?.getBoundingClientRect().width || track.getBoundingClientRect().width) + gap;
      track.scrollBy({ left: distance * direction, behavior: "smooth" });
    };

    prev.addEventListener("click", () => scrollTestimonials(-1));
    next.addEventListener("click", () => scrollTestimonials(1));
  });

  document.querySelectorAll("[data-blog-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-blog-track]");
    const prev = carousel.querySelector("[data-blog-prev]");
    const next = carousel.querySelector("[data-blog-next]");
    if (!track || !prev || !next) return;

    const scrollPosts = (direction) => {
      const firstCard = track.querySelector(".article-card--feed");
      const gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || "16");
      const distance = (firstCard?.getBoundingClientRect().width || track.getBoundingClientRect().width) + gap;
      track.scrollBy({ left: distance * direction, behavior: "smooth" });
    };

    prev.addEventListener("click", () => scrollPosts(-1));
    next.addEventListener("click", () => scrollPosts(1));
  });

  // FAQ category filter chips
  document.querySelectorAll("[data-faq-strip]").forEach((strip) => {
    const chips = strip.querySelectorAll("[data-faq-filter]");
    const items = strip.querySelectorAll(".faq-strip__item");
    if (!chips.length || !items.length) return;

    const applyFilter = (filter) => {
      chips.forEach((c) => {
        const active = c.dataset.faqFilter === filter;
        c.classList.toggle("is-active", active);
        c.setAttribute("aria-selected", active ? "true" : "false");
      });
      items.forEach((item) => {
        const cat = item.dataset.faqCategory || "";
        item.hidden = !(filter === "all" || cat === filter);
      });
    };

    chips.forEach((chip) => {
      chip.addEventListener("click", () => applyFilter(chip.dataset.faqFilter));
    });

    // Initial state: filter to the first chip's category
    const firstFilter = chips[0]?.dataset.faqFilter;
    if (firstFilter) applyFilter(firstFilter);
  });

  // Cart selling-plan picker: change a line item's plan via Shopify cart change API
  document.querySelectorAll("[data-cart-plan-select]").forEach((select) => {
    select.addEventListener("change", async (e) => {
      const lineKey = select.dataset.lineKey;
      const planId = select.value || "";
      select.disabled = true;
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: lineKey, selling_plan: planId === "" ? null : planId })
        });
        if (!res.ok) throw new Error(`Cart change failed: ${res.status}`);
        window.location.reload();
      } catch (err) {
        console.error(err);
        alert("Couldn't update that item. Please try again.");
        select.disabled = false;
      }
    });
  });

  // Subscribe & Save: toggle frequency dropdown, sync selling_plan submission, update price display
  const purchaseOptions = document.querySelector("[data-purchase-options]");
  if (purchaseOptions) {
    const oneTime = purchaseOptions.querySelector("[data-purchase-option-onetime]");
    const subscribe = purchaseOptions.querySelector("[data-purchase-option-subscribe]");
    const freqWrap = purchaseOptions.querySelector("[data-purchase-option-frequency]");
    const freqSelect = purchaseOptions.querySelector("[data-purchase-option-frequency-select]");
    const subPriceEl = purchaseOptions.querySelector("[data-purchase-option-sub-price]");
    const priceDisplayEl = document.querySelector("[data-product-price-display]");

    // Read the % discount from the badge text ("15% off" → 15) once for live price math
    const badgeEl = purchaseOptions.querySelector(".purchase-option__badge");
    const discountPct = badgeEl ? parseFloat(badgeEl.textContent) || 0 : 0;

    const formatMoneyFromText = (priceText, pctOff) => {
      // Parse "$24.00" → 24, apply discount, return same currency format
      const match = priceText.match(/([^\d.,\s]+)?\s*([\d,]+(?:\.\d+)?)/);
      if (!match) return priceText;
      const currency = match[1] || "$";
      const num = parseFloat(match[2].replace(/,/g, ""));
      const discounted = num * (1 - pctOff / 100);
      return `${currency}${discounted.toFixed(2)}`;
    };

    const updateSubPrice = () => {
      if (!subPriceEl || !priceDisplayEl) return;
      subPriceEl.textContent = formatMoneyFromText(priceDisplayEl.textContent, discountPct);
    };

    const setMode = (mode) => {
      if (mode === "subscribe") {
        if (freqWrap) freqWrap.hidden = false;
        if (freqSelect) {
          freqSelect.disabled = false;
          // When subscribe is on, the dropdown is the authoritative selling_plan value.
          // Disable the top-level radio input so its value doesn't double-submit.
          if (subscribe) subscribe.disabled = true;
        }
        updateSubPrice();
      } else {
        if (freqWrap) freqWrap.hidden = true;
        if (freqSelect) freqSelect.disabled = true;
        if (subscribe) subscribe.disabled = false;
      }
    };

    oneTime?.addEventListener("change", () => { if (oneTime.checked) setMode("onetime"); });
    subscribe?.addEventListener("change", () => { if (subscribe.checked) setMode("subscribe"); });

    // Re-update the subscription price when the variant changes (variant select fires below)
    document.addEventListener("essance:variant-changed", updateSubPrice);

    // Initial state
    setMode(subscribe?.checked ? "subscribe" : "onetime");
  }

  const productVariantSelect = document.querySelector("[data-product-variant-select]");
  if (productRoot && productVariantSelect) {
    const priceDisplay = document.querySelector("[data-product-price-display]");
    const stickyPrice = document.querySelector("[data-sticky-price]");
    const mainProductForms = document.querySelectorAll("form[data-product-form]");
    const stickyVariantInput = stickyAtc?.querySelector("input[name='id']");

    const syncSelectedVariant = () => {
      const selectedOption = productVariantSelect.options[productVariantSelect.selectedIndex];
      if (!selectedOption) return;

      const variantId = selectedOption.value;
      const variantPrice = selectedOption.dataset.variantPrice || "";
      const variantPriceRaw = selectedOption.dataset.variantPriceRaw || "";
      const isAvailable = !selectedOption.disabled;

      productRoot.dataset.productVariantId = variantId;
      if (variantPriceRaw) productRoot.dataset.productPrice = variantPriceRaw;
      if (priceDisplay && variantPrice) priceDisplay.textContent = variantPrice;
      if (stickyPrice && variantPrice) stickyPrice.textContent = variantPrice;
      if (stickyVariantInput) stickyVariantInput.value = variantId;

      mainProductForms.forEach((form) => {
        if (form.contains(productVariantSelect)) return;
        const hiddenVariantInput = form.querySelector("input[name='id']");
        if (hiddenVariantInput) hiddenVariantInput.value = variantId;
      });

      document.querySelectorAll("[data-main-atc], .sticky-atc-form button[type='submit']").forEach((button) => {
        button.disabled = !isAvailable;
        button.textContent = isAvailable ? "Add to Cart" : "Sold Out";
      });

      document.dispatchEvent(new CustomEvent("essance:variant-changed", { detail: { variantId, variantPrice } }));
    };

    productVariantSelect.addEventListener("change", syncSelectedVariant);
    syncSelectedVariant();
  }

  // #reviews hash: smooth-scroll to the Judge.me widget when present.
  // Judge.me loads async, so poll for ~2s before giving up gracefully.
  const REVIEW_SELECTORS = [
    "#judgeme_product_reviews",
    ".jdgm-rev-widg",
    ".jdgm-widget.jdgm-review-widget",
    ".jdgm-review-widget",
    "#shopify-product-reviews",
    "#reviews"
  ];

  const findReviewWidget = () => {
    for (const sel of REVIEW_SELECTORS) {
      const el = document.querySelector(sel);
      if (el && el.offsetHeight > 0) return el;
    }
    return null;
  };

  const scrollToReviewsWidget = () => {
    let attempts = 0;
    const maxAttempts = 20; // ~2 seconds at 100ms
    const tryScroll = () => {
      const el = findReviewWidget();
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(tryScroll, 100);
      }
    };
    tryScroll();
  };

  // On initial page load with #reviews hash
  if (window.location.hash === "#reviews") {
    // Wait one frame so the browser doesn't fight us with a default jump
    requestAnimationFrame(scrollToReviewsWidget);
  }

  // Intercept same-page clicks targeting #reviews
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href$="#reviews"]');
    if (!link) return;
    const href = link.getAttribute("href");
    const url = new URL(href, window.location.href);
    if (url.pathname === window.location.pathname) {
      e.preventDefault();
      history.replaceState(null, "", "#reviews");
      scrollToReviewsWidget();
    }
  });
})();
